

































































import "./invite-modal.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";
import Ajax from "../../lib/ajax";

export default Vue.extend({
  name: "UserEditor",
  components: { UserAvatar },
  props: {
    member: Object,
    show: Boolean,
  },
  data() {
    return {
      selectedUser: null,
      users: [],
      userResult: [],
      loading: false,
      email: null,
      role: 1,
      permission: 0,
      sending: false,
      collapsedPanel: "rolePanel",
      currentMember: {
        id: 0,
        name: "",
        memberAvatarImageUrl: null,
        emailAddress: "",
        isPreregistered: false,
        role: 1,
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please fill in your full name",
            trigger: "blur",
          },
        ],
        emailAddress: [
          {
            required: true,
            message: "Please enter email address",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Should be an email address.",
            trigger: "change",
          },
        ],
        role: [
          {
            required: true,
            type: "number",
            message: "Please select a role",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("billing", ["currentBillingAccountInviteRoles", "hasAccountAdminPermission"]),
    showModal: {
      get: function () {
        return (this as any).show;
      },
      set: function (newValue) {
        (this as any).$emit("cancel");
      },
    },
    currentUserRoleText() {
      let context = this as any;
      if (context.currentBillingAccountInviteRoles && context.currentMember && context.currentMember.role) {
        if (context.isPrimaryOwner(context.currentMember)) {
          return "Primary Account Owner";
        }

        if (context.isOwner(context.currentMember)) {
          return "Account Owner";
        }

        let roles = context.currentBillingAccountInviteRoles.filter((r) => r.value === context.currentMember.role);
        if (roles.length === 1) {
          return roles[0].title;
        }
      }

      return "";
    },
    roles() {
      let context = this as any;
      if (context.isOwner(context.currentMember) === true) {
        return [
          {
            value: 1,
            name: "admin",
            title: "Account Owner",
            disabled: true,
            description: "Can access and manage the entire account, including users and billing settings.",
          },
        ];
      } else {
        return context.currentBillingAccountInviteRoles;
      }
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        let context = this as any;
        context.currentMember.id = context.member.memberId;
        context.currentMember.isPreregistered = context.member.memberIsPreregistered;
        context.currentMember.name = context.member.memberName;
        context.currentMember.memberAvatarImageUrl = context.member.memberAvatarImageUrl;
        context.currentMember.emailAddress = context.member.memberEmailAddress;
        context.currentMember.role = context.member.role;
      }
    },
  },
  methods: {
    handleChangeOwner() {
      this.$emit("cancel");
      this.$emit("changeOwner");
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      this.sending = true;

      let context = this as any;

      (context.$refs["UserForm"] as any).validate((valid) => {
        if (valid) {
          let data = {
            memberId: context.currentMember.id,
            role: context.currentMember.role,
            email: context.currentMember.emailAddress,
            name: context.currentMember.name,
            billingAccountId: context.billingAccount.id,
          };

          this.$store
            .dispatch("billing/updateMember", {
              data: data,
            })
            .then((response) => {
              context.$store.dispatch("billing/getBillingAccountInfo", {
                id: context.billingAccount.id,
              });
              context.$emit("cancel");
            })
            .finally(() => {
              this.sending = false;
              target.disabled = false;
            });
        } else {
          context.sending = false;
          target.disabled = false;
          return;
        }
      });
    },
    handleUserSelectChange(value) {
      this.email = value;
    },
    isPrimaryOwner(user) {
      let context = this as any;
      return context.billingAccount && user && user.role === 1 && context.billingAccount.originalOwnerId === user.id;
    },
    isOwner(user) {
      let context = this as any;
      return context.billingAccount && user && user.role === 1;
    },
  },
});
